import { useCallback, useState } from 'react';

export const useBimWorkOrderPriceRevisionsFilter = () => {
    const [filterValues, setFilterValues] = useState<Record<string, string[]>>({});

    const changeFilterHandler = useCallback(({ fieldName, checkedValues }) => {
        const splitNames = fieldName.split('.');
        const keyName = splitNames[0] === 'object' ? splitNames[0] : splitNames[1];

        setFilterValues((prevValue) => ({
            ...prevValue,
            [keyName]: checkedValues,
        }));
    }, []);

    const clearFilter = useCallback(() => {
        setFilterValues({});
    }, []);

    return {
        filterValues,
        changeFilterHandler,
        clearFilter,
    };
};
